<ul>
  <li *ngFor="let item of inner_17025_Cat" class="MyMoeinListCat_Li">

    <div class="MyMoeinListCat_Div">
      <span class="MyMoeinListCat_Span">{{item.title}}</span>

      <i class="fa fa-eye" style="visibility: visible !important;" *ngIf="item.child.length>0 && item.childVisible" (click)="Change_Visible(item)"></i>
      <i class="fa fa-eye-slash" style="visibility: visible !important;" *ngIf="item.child.length>0 && !item.childVisible" (click)="Change_Visible(item)"></i>

      <i title="افزودن تگ" class="fa  fa-plus-circle MyMoeinListCat_Add" (click)="OnSet_Add_Action(item)"></i>
      <i title="ویرایش تگ" class="fa  fa-edit MyMoeinListCat_Edit" (click)="OnSet_Edit_Action(item)"></i>
      <i title="حذف تگ" class="fa  fa-remove MyMoeinListCat_Remove" (click)="OnSet_Remove_Action(item)"></i>
    </div>

    <app-Protocol17025Cat_Co
      [hidden]="item.childVisible==false"
      (On_Add_Action)="OnSet_Add_Action($event)"
      (On_Edit_Action)="OnSet_Edit_Action($event)"
      (On_Remove_Action)="OnSet_Remove_Action($event)"
      [inner_17025_Cat]="item.child">

    </app-Protocol17025Cat_Co>

  </li>
</ul>
